import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';
import { CostTableListData } from '@Types/costTable.types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const costTablesStoreSelector = createSelector(
  parseNamespace,
  state => state.CostTablesStore
);

const costTablesOverviewSelector = createSelector(
  costTablesStoreSelector,
  costTablesStoreSelector => ({
    status: costTablesStoreSelector.costTablesOverview.status,
    pagination: costTablesStoreSelector.costTablesOverview.pagination,
    totalCount: costTablesStoreSelector.costTablesOverview.totalCount,
    costTables: costTablesStoreSelector.costTablesOverview
      .rows as CostTableListData[],
    isLoading: costTablesStoreSelector.costTablesOverview.isLoading,
    isWaiting: costTablesStoreSelector.costTablesOverview.isWaiting,
    successful: costTablesStoreSelector.costTablesOverview.successful,
  })
);

const costTableDetailsSelector = createSelector(
  costTablesStoreSelector,
  costTablesStoreSelector => ({
    status: costTablesStoreSelector.costTableDetails?.status || null,
    costTable: costTablesStoreSelector.costTableDetails?.costTable || null,
    costTableData:
      costTablesStoreSelector.costTableDetails?.costTableData || [],
    isLoading: costTablesStoreSelector.costTableDetails?.isLoading || false,
    isWaiting: costTablesStoreSelector.costTableDetails?.isWaiting || false,
    successful: costTablesStoreSelector.costTableDetails?.successful ?? null,
  })
);

const costTableListGridStateSelector = createSelector(
  costTablesStoreSelector,
  s => s.costTableListGridState
);

export const useCostTablesOverview = () =>
  useSelector(costTablesOverviewSelector);

export const useCostTableListGridState = () =>
  useSelector(costTableListGridStateSelector);

export const useCostTableDetails = () => useSelector(costTableDetailsSelector);
